import { render, staticRenderFns } from "./VueDag.vue?vue&type=template&id=506b3dfa&"
import script from "./VueDag.vue?vue&type=script&lang=ts&"
export * from "./VueDag.vue?vue&type=script&lang=ts&"
import style0 from "./VueDag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports